var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BDropdownItemButton',_vm._g({attrs:{"button-class":[
    'd-flex justify-content-between text-nowrap',
    {[`text-${_vm.variant}`]: _vm.variant}
  ]}},_vm.$listeners),[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.text)+" ")]}),(_vm.icon)?_c('Icon',{staticClass:"ml-4",attrs:{"icon":_vm.icon}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }